export default __webpack_public_path__ + "static/img/4.fd95905.png";